import { z } from "zod";
import { CONTENT, STATE } from "./consts";

export const addSchema = z.object({
  [STATE]: z.string().min(1, "This field is required"),
  [CONTENT]: z.string().min(1, "This field is required"),
});

export type AddZoneFormValues = z.infer<typeof addSchema>;
